import BasePage from "@Scripts/Pages/BasePage";
import CanvasScrollClip from "canvas-scroll-clip";

export default class HomePage extends BasePage {
    public static async init() {
        await super.init();

        this.setServiceHome();
        this.setCanvasScrollClip();
        this.setMagazine();
        this.setHomeAnimation();
    }

    private static setHomeAnimation() {
        gsap.registerPlugin(ScrollTrigger);

        gsap.to(".home-intro .main-title.s40", {
            transform: "scale(1)",
            marginTop: "0px",
            opacity: 1,
            scrollTrigger: {
                trigger: ".home-intro",
                start: "center 95%",
                end: "center 65%",
                scrub: true,
            }
        });

        gsap.to(".home-search-image .box-image", {
            translateY: 0,
            scrollTrigger: {
                trigger: ".home-search-image .box-image",
                end: "center 50%",
                scrub: true,
            }
        });

        gsap.to(".home-search-image .layer02", {
            opacity: 1,
            scrollTrigger: {
                trigger: ".home-search-image .layer02",
                start: "top 40%",
                end: "top 30%",
                scrub: true,
            }
        });

        gsap.to(".home-search-image .layer03", {
            opacity: 1,
            scrollTrigger: {
                trigger: ".home-search-image",
                start: "top 40%",
                end: "top 41%",
                scrub: true,
            }
        });

        gsap.to(".home-search-image .layer03 img", {
            opacity: 0,
            scrollTrigger: {
                trigger: ".home-search-image",
                start: "top 30%",
                end: "top 25%",
                scrub: true,
            }
        });

        gsap.to(".home-search-image .layer04", {
            opacity: 1,
            scrollTrigger: {
                trigger: ".home-search-image",
                start: "top 25%",
                end: "top 26%",
                scrub: true,
            }
        });

        gsap.to(".home-search-image .layer04 img", {
            opacity: 0,
            scrollTrigger: {
                trigger: ".home-search-image",
                start: "top 15%",
                end: "top 10%",
                scrub: true,
            }
        });

        gsap.to(".home-search-image .layer05", {
            opacity: 1,
            scrollTrigger: {
                trigger: ".home-search-image",
                start: "top 15%",
                end: "top 10%",
                scrub: true,
            }
        });

        gsap.to(".canvas-title", {
            transform: "scale(1)",
            opacity: 1,
            scrollTrigger: {
                trigger: ".canvas-title",
                start: "top 100%",
                end: "+=500",
                scrub: true
            }
        });
    }

    private static setServiceHome() {
        window.addEventListener("scroll", (event) => {
            let panel = document.querySelectorAll(".service-area"),
                serviceArea = document.getElementById("ServiceArea"),
                scroll = window.scrollY + (window.screen.height / 3);

            for (var i = 0; i < panel.length; i++) {
                let thisPanel = panel[i];

                if ((<HTMLElement>thisPanel).offsetTop <= scroll && (<HTMLElement>thisPanel).offsetTop + (<HTMLElement>thisPanel).offsetHeight > scroll) {
                    serviceArea.className = "";
                    serviceArea.classList.add((<HTMLElement>thisPanel).dataset.layout + "-area");
                }
            };
        });
    }

    private static setCanvasScrollClip() {
        new CanvasScrollClip(document.querySelector('.canvas-container'), {
            framePath: "images/home/image0000.webp",
            frameCount: 171,
            scrollArea: 4000
        });
    }

    private static setMagazine() {
        const visuals = new (<any>window).Swiper(".elements-carosel", {
            modules: [(<any>window).Pagination, (<any>window).Navigation],
            slidesPerView: "auto",
            centeredSlides: true,
            pagination: {
                el: ".slide-count",
                type: "bullets",
                clickable: false,
                renderBullet: function (index, className) {
                    return "<div class=\"item \ " + className + "\"></div>";
                }
            },
            navigation: {
                nextEl: ".button-next",
                prevEl: ".button-prev",
            }
        });
    }
}